import AuthService from '../services/AuthService';

export default {
    template: '#auth-module',
    events: {
        'open-login': function () {
            this.showLogin();
        },
        'open-register': function () {
            this.showRegister();
        },
        'close-auth': function () {
            this.closeAuth();
        }
    },
    data () {
        return {
            modalTitle: 'LOG IN TO VIRALSTYLE',
            currentView: 'LOGIN',
            login: {
                email: '',
                password: '',
                remember: false,
                showError: false,
                errorMessage: ''
            },
            forgot: {
                email: '',
                passwordSuccess: false,
                showError: false,
                errorMessage: ''
            },
            register: {
                name: '',
                public_name: 'ny-designer',
                email: '',
                password: '',
                confirm: '',
                refId: '',
                terms: false,
                showError: false,
                errorMessage: ''
            },
            buttons: {
                signIn: {
                    text: 'LOG IN',
                    disabled: false
                },
                register: {
                    text: 'SIGN UP',
                    disabled: false
                },
                forgotPassword: {
                    text: 'RETRIEVE PASSWORD',
                    disabled: false
                }
            },
            validations: {
                signIn: {
                    email: {
                        empty: false,
                        inValid: false,
                        messageEmpty: 'Please enter your email address.',
                        messageInvalid: 'Please enter a valid email address.',
                        showError: false
                    },
                    password: {
                        empty: false,
                        messageEmpty: 'Please enter your password.',
                        showError: false
                    }
                },
                register: {
                    name: {
                        empty: false,
                        messageEmpty: 'Please enter your full name.',
                        showError: false
                    },
                    public_name: {
                        empty: false,
                        messageEmpty: 'Please enter a public name.',
                        maxAllowedLength: 20,
                        lengthInvalid: false,
                        lengthInvalidErrorText: 'Public name must be less than 30 characters.',
                        alreadyExists: false,
                        alreadyExistsErrorText: '',
                        showError: false
                    },
                    email: {
                        empty: false,
                        alreadyExists: false,
                        invalid: false,
                        alreadyExistsErrorText: 'Email has already been registered.',
                        emptyErrorText: 'Please enter your email address.',
                        invalidEmailErrorText: 'Please enter a valid email address.',
                        showError: false
                    },
                    password: {
                        empty: false,
                        emptyErrorText: 'Please enter your password.',
                        minLength: 8,
                        maxLength: 20,
                        lengthInvalid: false,
                        lengthInvalidErrorText: 'Password must be between 8 and 20 characters.',
                        showError: false
                    },
                    passwordConfirm: {
                        empty: false,
                        emptyErrorText: 'Please confirm your password.',
                        compareFailed: false,
                        compareFailedErrorText: 'Passwords do not match.',
                        showError: false
                    },
                    terms: {
                        empty: false,
                        emptyErrorText: 'Please accept the terms & conditions.',
                        showError: false
                    }
                },
                forgotPassword: {
                    email: {
                        empty: false,
                        inValid: false,
                        messageEmpty: 'Please enter your email address.',
                        messageInvalid: 'Please enter a valid email address.',
                        showError: false
                    }
                }
            },
            config: {
                modal: {
                    keyboard: false,
                    show: true,
                    backdrop: 'static'
                }
            },
            loginRecaptchaId: null,
            registerRecaptchaId: null
        }
    },
    created() {
      window.dataLayer.push({'event': 'load-vs-tags'});
      window.grecaptchaLoad = this.$_initGrecaptcha;
    },
    watch: {
        'register.public_name': function (val) {
            this.checkPublicName();
        }
    },
    methods: {
        $_initGrecaptcha() {
          let sitekey;

          if (process.env.NODE_ENV === 'production') sitekey = '6Le38UwUAAAAAF9oVshcQL21zzq7Q8FP_oyLfaKk';
          else sitekey = '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI';

          this.loginRecaptchaId = window.grecaptcha.render('designer_recaptcha_login', {
            sitekey,
            size: 'invisible',
            callback: token => this.loginRecaptchaCallback(token),
          });

          this.registerRecaptchaId = window.grecaptcha.render('designer_recaptcha_register', {
            sitekey,
            size: 'invisible',
            callback: token => this.registerRecaptchaCallback(token),
          });
        },
        emptyAutoPopulatedFields(){
            this.login.email = '';
            this.login.password = '';
            this.login.remember = false;
            this.register.email = '';
            this.register.name = '';
            this.register.password = '';
            this.register.confirm = '';
            this.register.terms = false;
            this.forgot.email = '';
        },
        showLogin(){
            this.currentView = 'LOGIN';
            this.modalTitle = 'LOG IN TO VIRALSTYLE';
            this.emptyAutoPopulatedFields();
            $('#modalLogin').modal(this.config.modal);
        },
        showForgotPassword(){
            this.currentView = 'FORGOT-PASSWORD';
            this.modalTitle = 'FORGOT PASSWORD';
            this.forgot.passwordSuccess = false;
            this.emptyAutoPopulatedFields();
            $('#modalLogin').modal(this.config.modal);
        },
        showRegister(){
            this.currentView = 'REGISTER';
            this.modalTitle = 'CREATE ACCOUNT';
            this.emptyAutoPopulatedFields();
            $('#modalLogin').modal(this.config.modal);
        },
        closeAuth(){
            $('#modalLogin').modal('hide');
        },
        submitLogin() {
          this.login.showError = false;
          this.login.errorMessage = '';
          if (this.validateSignIn()) window.grecaptcha.execute(this.loginRecaptchaId);
        },
        loginRecaptchaCallback(token) {
            this.onLogin(token);
        },
        onLogin(token){
            window.grecaptcha.reset(this.loginRecaptchaId);

            this.onProcessing();

            this.getAuthService().login(this.login.email, this.login.password, this.login.remember, token,
                (user)=> {  //Success
                    this.$dispatch('on-user-logged-in', user);
                    this.onProcessed();
                    this.closeAuth();
                },
                (response)=> {  //Failure
                    this.onProcessed();
                    this.login.errorMessage = 'Login Error: ' + response.message;
                    this.login.showError = true;
                }
            );
        },
        submitRegister() {
          if (this.validateRegister()) window.grecaptcha.execute(this.registerRecaptchaId);
        },
        registerRecaptchaCallback(token) {
            this.onRegister(token);
        },
        onRegister(token){
            window.grecaptcha.reset(this.registerRecaptchaId);

            this.onProcessing();

            this.getAuthService().register(
                this.register.name, this.register.public_name, this.register.email, this.register.password, this.register.terms, this.register.refId, token,
                (user) => {  //Success
                    this.$dispatch('on-user-logged-in', user);
                    this.onProcessed();
                    this.closeAuth();
                    this._handleGTMRegister();
                },
                (response) => {  //Failure
                    this.onProcessed();
                    this.register.errorMessage = 'Registration Error: ' + response.message;
                    this.register.showError = true;
                }
            );
        },
        onForgotPassword(){
            if (this.validateForgotPassword()) {
                this.onProcessing();
                this.getAuthService().resetPasswordRequest(
                    this.forgot.email,
                    () => {
                        this.onProcessed();
                        this.forgot.passwordSuccess = true;
                    },
                    (response)=> {
                        this.onProcessed();
                        this.register.errorMessage = 'Password Reset Error: ' + response.message;
                        this.register.showError = true;
                    }
                )
            }
        },
        logout(){
            this.getAuthService().logout()
        },
        getAuthService(){
            return new AuthService(this.$root.service.request.object);
        },
        checkPublicName(e){
            if (e && e.toString() == "[object FocusEvent]") {
                if (_.isEmpty(this.register.public_name)) {
                    this.register.public_name = 'ny-designer';
                }
            }
            this.getAuthService().verifyPublicName(this.register.public_name,
                ()=> {
                    this.validations.register.public_name.alreadyExists = false;
                    this.validations.register.public_name.showError = false;
                    this.validations.register.public_name.alreadyExistsErrorText = '';
                },
                (response)=> {
                    this.validations.register.public_name.alreadyExistsErrorText = response.message;
                    this.validations.register.public_name.alreadyExists = true;
                    this.validations.register.public_name.showError = true;
                });
        },
        checkEmailExists(){
            if (!_.isEmpty(this.register.email) && is.email(this.register.email)) {
                this.getAuthService().verifyEmailAddress(this.register.email,
                    ()=> {
                        this.validations.register.email.alreadyExists = false;
                        this.validations.register.email.showError = false;
                    },
                    (response)=> {
                        this.validations.register.public_name.alreadyExistsErrorText = response.message;
                        this.validations.register.email.alreadyExists = true;
                        this.validations.register.email.showError = true;
                    });
            }
        },
        onProcessing(){
            if (this.currentView == 'LOGIN') {
                this.buttons.signIn.text = 'o o o';
                this.buttons.signIn.disabled = true;
            }

            if (this.currentView == 'REGISTER') {
                this.buttons.register.text = 'o o o o';
                this.buttons.register.disabled = true;
            }

            if (this.currentView == 'FORGOT-PASSWORD') {
                this.buttons.forgotPassword.text = 'o o o o';
                this.buttons.forgotPassword.disabled = true;
            }
        },
        onProcessed(){
            if (this.currentView == 'LOGIN') {
                this.buttons.signIn.text = 'LOGIN';
                this.buttons.signIn.disabled = false;
            }

            if (this.currentView == 'REGISTER') {
                this.buttons.register.text = 'SIGN UP';
                this.buttons.register.disabled = false;
            }

            if (this.currentView == 'FORGOT-PASSWORD') {
                this.buttons.forgotPassword.text = 'RETRIEVE PASSWORD';
                this.buttons.forgotPassword.disabled = false;
            }
        },
        validateSignIn(){
            this.validations.signIn.email.empty = _.isEmpty(this.login.email);
            this.validations.signIn.email.inValid = false;

            this.validations.signIn.email.inValid = (this.validations.signIn.email.empty === false && is.email(this.login.email) === false)

            this.validations.signIn.password.empty = _.isEmpty(this.login.password);

            this.validations.signIn.email.showError = (this.validations.signIn.email.empty || this.validations.signIn.email.inValid);
            this.validations.signIn.password.showError = this.validations.signIn.password.empty;

            return !(this.validations.signIn.email.showError || this.validations.signIn.password.showError);
        },
        validateForgotPassword(){
            this.validations.forgotPassword.email.empty = _.isEmpty(this.forgot.email);

            this.validations.forgotPassword.email.inValid = (this.validations.forgotPassword.email.empty === false && is.email(this.forgot.email) === false)

            this.validations.forgotPassword.email.showError = (this.validations.forgotPassword.email.empty || this.validations.forgotPassword.email.inValid);

            return !(this.validations.forgotPassword.email.showError);
        },
        validateRegister(){
            this.validations.register.name.empty = _.isEmpty(this.register.name);
            this.validations.register.name.showError = (this.validations.register.name.empty);
            this.validations.register.public_name.empty = _.isEmpty(this.register.public_name);
            this.validations.register.email.empty = _.isEmpty(this.register.email);
            this.validations.register.password.empty = _.isEmpty(this.register.password);
            this.validations.register.passwordConfirm.empty = _.isEmpty(this.register.confirm);

            this.validations.register.public_name.lengthLessThan20ErrorText = (this.validations.register.public_name.empty === false && this.register.public_name.length > this.validations.register.public_name.maxAllowedLength);

            this.validations.register.public_name.showError = (this.validations.register.public_name.empty || this.validations.register.public_name.lengthInvalid || this.validations.register.public_name.alreadyExists);

            this.validations.register.email.invalid = (this.validations.register.email.empty === false && is.email(this.register.email) === false);

            this.validations.register.email.showError = (this.validations.register.email.empty || this.validations.register.email.invalid || this.validations.register.email.alreadyExists);

            this.validations.register.password.lengthInvalid = (this.validations.register.password.empty === false && (this.register.password.length < this.validations.register.password.minLength || this.register.password.length > this.validations.register.password.maxLength))

            this.validations.register.password.showError = (this.validations.register.password.empty || this.validations.register.password.lengthInvalid);

            this.validations.register.passwordConfirm.compareFailed = (this.validations.register.passwordConfirm.empty === false && this.register.password != this.register.confirm);

            this.validations.register.passwordConfirm.showError = (this.validations.register.passwordConfirm.empty || this.validations.register.passwordConfirm.compareFailed);

            this.validations.register.terms.empty = (!this.register.terms)

            this.validations.register.terms.showError = this.validations.register.terms.empty;

            return (!(this.validations.register.name.showError || this.validations.register.public_name.showError ||
            this.validations.register.email.showError || this.validations.register.password.showError ||
            this.validations.register.passwordConfirm.showError || this.validations.register.passwordConfirm.showError))
        },
        _handleGTMRegister() {
          let isProduction = document.getElementById('auth-module').dataset.environment === 'production',
            googleId, googleDomain, retargetId, adwordsId;

          if (isProduction) {
            googleId = 'UA-51001413-1';
            googleDomain = 'viralstyle.com';
            retargetId = 967338940;
            adwordsId = 935221422;
          } else {
            googleId = 'UA-73140867-1';
            googleDomain = 'viral-tees.app';
            retargetId = 111111111;
            adwordsId = 112233445;
          }

          window.dataLayer.push({ 'vsGoogleAnalyticsId': googleId });
          window.dataLayer.push({ 'vsGoogleAnalyticsDomain': googleDomain });
          window.dataLayer.push({
            'vsGoogleRemarketingRegisterPayload': {
              google_conversion_id: retargetId,
              google_conversion_label: "8wYGCPD75WYQvNehzQM",
              google_conversion_format: "3",
              google_remarketing_only: false
            }
          });
          window.dataLayer.push({
            'vsGoogleRemarketingRegister2Payload': {
              google_conversion_id: adwordsId,
              google_conversion_label: "ivwfCODPoGcQrrH5vQM",
              google_conversion_format: "3",
              google_remarketing_only: false
            }
          });

          window.dataLayer.push({ 'event': 'register-tracking' });
        }
    },
    computed: {
        loginEmailFilled(){
            return !_.isEmpty(this.login.email);
        },
        loginPasswordFilled(){
            return !_.isEmpty(this.login.password);
        },
        forgotEmailFilled(){
            return !_.isEmpty(this.forgot.email);
        },
        showLoginEmailErrorText(){
            return this.validations.signIn.email.showError;
        },
        loginEmailErrorText(){
            if (this.validations.signIn.email.inValid) {
                return this.validations.signIn.email.messageInvalid;
            }

            if (this.validations.signIn.email.empty) {
                return this.validations.signIn.email.messageEmpty;
            }
        },
        showLoginPasswordError(){
            return this.validations.signIn.password.showError;
        },
        loginPasswordErrorText(){
            if (this.validations.signIn.password.empty) {
                return this.validations.signIn.password.messageEmpty;
            }
        },
        registerNameFilled(){
            return !_.isEmpty(this.register.name);
        },
        registerPublicNameFilled(){
            return !_.isEmpty(this.register.public_name);
        },
        registerEmailFilled(){
            return !_.isEmpty(this.register.email);
        },
        registerPasswordFilled(){
            return !_.isEmpty(this.register.password);
        },
        registerPasswordConfirmFilled(){
            return !_.isEmpty(this.register.confirm);
        },
        showRegisterNameErrorText(){
            return this.validations.register.name.showError;
        },
        registerNameErrorText(){
            if (this.validations.register.name.empty)
                return this.validations.register.name.messageEmpty;
        },
        showRegisterPublicNameErrorText(){
            return this.validations.register.public_name.showError;
        },
        registerPublicNameErrorText(){
            if (this.validations.register.public_name.empty)
                return this.validations.register.public_name.messageEmpty;

            if (this.validations.register.public_name.lengthInvalid)
                return this.validations.register.public_name.lengthInvalidErrorText;

            if (this.validations.register.public_name.alreadyExists)
                return this.validations.register.public_name.alreadyExistsErrorText;
        },
        showRegisterEmailErrorText(){
            return this.validations.register.email.showError;
        },
        registerEmailErrorText(){
            if (this.validations.register.email.empty)
                return this.validations.register.email.emptyErrorText;

            if (this.validations.register.email.invalid)
                return this.validations.register.email.invalidEmailErrorText;

            if (this.validations.register.email.alreadyExists)
                return this.validations.register.email.alreadyExistsErrorText;
        },
        showRegisterPasswordErrorText(){
            return this.validations.register.password.showError;
        },
        registerPasswordErrorText(){
            if (this.validations.register.password.empty)
                return this.validations.register.password.emptyErrorText;

            if (this.validations.register.password.lengthInvalid)
                return this.validations.register.password.lengthInvalidErrorText;
        },
        showRegisterConfirmPasswordErrorText(){
            return this.validations.register.passwordConfirm.showError;
        },
        registerConfirmPasswordErrorText(){
            if (this.validations.register.password.empty)
                return this.validations.register.passwordConfirm.emptyErrorText;

            if (this.validations.register.passwordConfirm.compareFailed)
                return this.validations.register.passwordConfirm.compareFailedErrorText;
        },
        showRegisterTermsErrorText(){
            return this.validations.register.terms.empty;
        },
        registerTermsErrorText(){
            if (this.validations.register.terms.empty)
                return this.validations.register.terms.emptyErrorText;
        },
        showForgotEmailErrorText(){
            return this.validations.forgotPassword.email.showError;
        },
        forgotEmailErrorText(){
            if (this.validations.forgotPassword.email.inValid) {
                return this.validations.forgotPassword.email.messageInvalid;
            }

            if (this.validations.forgotPassword.email.empty) {
                return this.validations.forgotPassword.email.messageEmpty;
            }
        }
    }
};


// WEBPACK FOOTER //
// ./app/assets/js/client-admin/designer/components/auth.js